<input
  #input
  type="file"
  [multiple]="isMultiple()"
  hidden
  (change)="onInputChange()"
  [disabled]="disabled()"
/>

<div class="button-group">
  @if (enablePhotoPicker()) {
    <div class="photo-menu-trigger">
      <ui-button buttonStyle="outlined" (clicked)="photoMenuTrigger.openMenu()" [disabled]="disabled()">
        <ui-icon faName="camera" faStyle="light"></ui-icon>
        <span>{{ photoButtonText() }}</span>
      </ui-button>

      <!-- The menu opens at this anchor in the middle of the button -->
      <span
        class="photo-menu-anchor"
        #photoMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="photoMenu"
        (menuOpened)="photoMenu.focusFirstItem('touch')"
      ></span>
    </div>

    <mat-menu #photoMenu="matMenu" class="photo-menu">
      <button mat-menu-item (click)="takePhoto()">
        <span class="photo-menu-item">
          <ui-icon faName="camera" faStyle="light"></ui-icon>
          <span>{{ photoMenuStrings.takePhoto }}</span>
        </span>
      </button>
      <button mat-menu-item (click)="pickFromMediaLibrary()">
        <span class="photo-menu-item">
          <ui-icon faName="images" faStyle="light"></ui-icon>
          <span>{{ photoMenuStrings.mediaLibrary }}</span>
        </span>
      </button>
    </mat-menu>
  } @else if (enableCamera()) {
    <ui-button buttonStyle="outlined" (click)="pickFiles('camera')" [disabled]="disabled()">
      <ui-icon faName="camera" faStyle="light"></ui-icon>
      <span>{{ cameraButtonText() }}</span>
    </ui-button>
  }

  @if (enableFileDialog()) {
    <ui-button buttonStyle="outlined" (click)="pickFiles('dialog')" [disabled]="disabled()">
      <ui-icon faName="file" faStyle="light"></ui-icon>
      <span>{{ fileButtonText() }}</span>
    </ui-button>
  }
</div>
